import AgentBank from "../pages/agent_bank/agent_bank";
import Avatar from "../pages/avatar/avatar";
import DashboardPage from "../pages/dashboard";
import Operator from "../pages/operator/operator";
import AgentUpdateUI from "../pages/ui/agent_update_ui";
import User from "../pages/user/user";
import Transaction from "../pages/transaction/transaction";
import Social from "../pages/social/social";
import Setting from "../pages/setting/setting";

export const routes = [
  { path: "/", element: <DashboardPage /> },
  { path: "/user", element: <User /> },
  { path: "/operator", element: <Operator /> },
  { path: "/agent_bank", element: <AgentBank /> },
  { path: "/transaction", element: <Transaction /> },
  { path: "/social", element: <Social /> },
  { path: "/avatar", element: <Avatar /> },
  { path: "/ui", element: <AgentUpdateUI /> },
  { path: "setting", element: <Setting /> },
];
